import inputStrings from 'utils/inputStrings'
import {
  SLOT_TYPES,
  IGNITION_VALUES,
  getGearValue,
} from 'utils/logicalSlotConversions'
import { getTimerOutputSemanticValue } from 'utils/supportParameter'
import { getEnumValue, CHEC_MAX_VALUE } from 'utils/constants.js'

const stringMaxVal = CHEC_MAX_VALUE.toString()

const AVAILABLE_FOR_USE = 'AVAILABLE FOR USE'
const getIgnitionValue = (index) => {
  const ret = getEnumValue(IGNITION_VALUES, Number(index))
  if (ret == null) return inputStrings.unavailable
  return ret
}

// Note: Remove after 58 QA cycle is complete and released.
//   const getIgnitionIndex = (value) => {
//   const ret = getEnumIndex(IGNITION_VALUES, String(value))
//   if (ret === -1) return stringMaxVal
//   return String(ret)
// }

export const inputs = [
  {
    value: 65535,
    description: `Default`,
    short: 'DFLT',
    isInput: true,
    isOutput: true,
  },
  {
    value: 0,
    description: `A/C Clutch Request DI`,
    short: `A/C CL REQ`,
    isInput: true,
    isOutput: false,
    disp: (op, value) => {
      if (value > 0) {
        return `AC CL ON`
      }
      return `AC CL OFF`
    },
  },
  { value: 1, description: `A/C Clutch DO`, short: 'AC CL DO' },
  { value: 2, description: `A/C Clutch Current Sense` },
  { value: 3, description: `Alternator Charging Input` },
  { value: 4, description: `No Charge Indicator DO` },
  { value: 5, description: `Panel Lamp Increase DI` },
  { value: 6, description: `Panel Lamp Decrease DI` },
  { value: 7, description: `Panel Lamp Backlight PWM Output` },
  { value: 8, description: `Panel Lamp Current Sense AI` },
  { value: 9, description: `Panel Lamp Feedback AI` },
  { value: 10, description: `Backup Input` },
  { value: 11, description: `Backup Lamps / Alarm DO` },
  { value: 12, description: `Backup Lamps /Alarm Current Sense` },
  {
    value: 13,
    description: `Current Gear CAN Message`,
    short: 'CURR GEAR CAN',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `CURR GEAR CAN ${op} ${val}`,
    semanticDisplay: (op, val) => `Trans current gear ${getGearValue(val, op)}`,
  },
  {
    value: 14,
    description: `Current Range CAN Message`,
    short: 'CURR RNG CAN',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `CURR RNG CAN ${op} ${val}`,
  },
  {
    value: 15,
    description: `Selected Gear CAN Message`,
    short: 'SEL GEAR CAN',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `SEL GEAR CAN ${op} ${val}`,
    semanticDisplay: (op, val) => `Trans next gear ${getGearValue(val, op)}`,
  },
  { value: 16, description: `Dome Lamps Battery Power DO On` },
  { value: 17, description: `Dome Lamps Battery Power DO Off` },
  { value: 18, description: `Dome Lamp Battery Power Current Sense` },
  { value: 19, description: `Cigar Lighter On DO` },
  { value: 20, description: `Cigar Lighter Off DO` },
  { value: 21, description: `Cigar Lighter Voltage Feedback ` },
  { value: 22, description: `Cigar Lighter Current Sense` },
  {
    value: 23,
    description: `Bottom of Clutch Switch DI`,
    short: 'CLUTCH BOT SW',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `CLUTCH BOT SW ${op} ${val}`,
  },
  { value: 24, description: `Top of Clutch Switch DI` },
  { value: 25, description: `J1939 Parameter Clutch Switch` },
  { value: 26, description: `Driver Side Door Jamb DI` },
  { value: 27, description: `Passenger Side Door Jamb DI` },
  { value: 28, description: `Dome Lamps Switched Power DO` },
  { value: 29, description: `Dome Lamps Switched Power Current Sense` },
  { value: 30, description: `Horn Switch ` },
  {
    value: 31,
    description: `Horn On Output DO`,
    short: 'HORN ON',
    isInput: false,
    isOutput: true,
    disp: (op, value) => {
      if (value > 0) {
        return `HORN ON`
      }
      return `HORN OFF`
    },
  },
  { value: 32, description: `Horn Off Output DO` },
  { value: 33, description: `Horn Current Sense AI` },
  { value: 34, description: `Horn Feedback AI` },
  { value: 35, description: `Fuel Level AI` },
  {
    value: 36,
    description: `J1939 Parameter Fuel Level`,
    short: 'FUEL LVL',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `FUEL LVL ${op} ${val}`,
  },
  { value: 37, description: `Hazard DI` },
  {
    value: 38,
    description: `J1939 Parameter 4 Way / Hazard Switch Position Feedback`,
  },
  {
    value: 39,
    description: `J1939 Parameter 4 Way / Hazard Telltale Lamps Feedback`,
  },
  {
    value: 40,
    description: `J1939 Parameter 4 Way / Hazard Switch Position`,
  },
  { value: 41, description: `Headlamp On DI` },
  { value: 42, description: `Head Lamp On 2 DI` },
  { value: 43, description: `Headlamp Park DI` },
  { value: 44, description: `J1939 Parameter High Beam Switch DI` },
  {
    value: 45,
    description: `J1939 Parameter High Beam-Flash to Pass Feedback`,
  },
  { value: 46, description: `Right High Beam DO` },
  { value: 47, description: `Right High Beam Current Sense AI` },
  { value: 48, description: `Left High Beam DO` },
  { value: 49, description: `Left High Beam Current Sense` },
  { value: 50, description: `Right Low Beam DO` },
  { value: 51, description: `Right Low Beam Current Sense AI` },
  { value: 52, description: `Left Low Beam On DO` },
  { value: 53, description: `Left Low Beam Off DO` },
  { value: 54, description: `Left Low Beam Current Sense AI` },
  { value: 55, description: `Park / Marker Lamps DO` },
  { value: 56, description: `Park / Marker Lamps Current Sense AI` },
  { value: 57, description: `Park / Marker Lamps Status DI` },
  { value: 58, description: `Tail / Clearance / License Plate Lamps On DO` },
  { value: 59, description: `Tail / Clearance / License Plate Lamps Off DO` },
  {
    value: 60,
    description: `Tail / Clearance / License Plate Lamps Current Sense AI`,
  },
  {
    value: 61,
    description: `Ignition Switch On DI`,
    short: 'IGN ON',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `IGN ${Number(val) ? '' : 'NOT '}ON`,
  },
  {
    value: 62,
    description: `Ignition Switch Acc DI`,
    short: 'IGN ACC',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `IGN ${Number(val) ? '' : 'NOT '}ACC`,
  },
  {
    value: 63,
    description: `Ignition Switch Crank DI`,
    short: 'IGN CRANK',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `IGN ${Number(val) ? '' : 'NOT '}CRANK`,
  },
  {
    value: 64,
    description: `Ignition On Outputs On DO`,
    short: 'IGN ON OUT ON',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `IGN ON OUT ON ${op} ${val}`,
  },
  { value: 65, description: `Ignition On Outputs Off DO` },
  { value: 66, description: `Ignition On Outputs Current Sense` },
  { value: 67, description: `Ignition Accessory Output` },
  { value: 68, description: `Ignition Accessory Output Current Sense` },
  { value: 69, description: `Starter Relay Engage DO` },
  { value: 70, description: `Starter Relay Disengage DO` },
  { value: 71, description: `Starter Relay Current Sense AI` },
  {
    value: 72,
    description: `Park Brake Switch`,
    short: 'PRK BRK',
    isInput: true,
    isOutput: false,
    disp: (op, value) => {
      if (value > 0) {
        return `PRK BRK ON`
      }
      return `PRK BRK OFF`
    },
  },
  { value: 73, description: `J1939 Parameter Parking Brake Switch` },
  { value: 74, description: `Wake Up / Cluster Power` },
  { value: 75, description: `Wake Up / Cluster Power Current Sense` },
  { value: 76, description: `Service Brake DI` },
  { value: 77, description: `J1939 Parameter Brake Switch` },
  {
    value: 78,
    description: `J1939 Parameter Brake Switch from ABS`,
    short: 'ABS BRK',
    isInput: true,
    isOutput: false,
    disp: (op, value) => {
      if (value > 0) {
        return `ABS BRK ON`
      }
      return `ABS BRK OFF`
    },
  },
  {
    value: 79,
    description: `Left Stop Lamp DO (Same as Left Combo Stop/Turn)`,
  },
  { value: 80, description: `Left Stop Lamp Current Sense AI` },
  {
    value: 81,
    description: `Right Stop Lamp DO (Same as Right Combo Stop/Turn)`,
  },
  { value: 82, description: `Right Stop Lamp Current Sense AI` },
  { value: 83, description: `Service Brake Override DO` },
  { value: 84, description: `Trailer Stop Lamp Relay DO` },
  { value: 85, description: `Trailer Stop Lamp Relay Status DI` },
  { value: 86, description: `J1939 Parameter Left Turn Switch Position` },
  { value: 87, description: `J1939 Parameter Right Turn Switch Position` },
  { value: 88, description: `J1939 Parameter Left Turn Switch Feedback` },
  { value: 89, description: `J1939 Parameter Right Turn Switch Feedback` },
  {
    value: 90,
    description: `J1939 Parameter Left Turn Lamps Feedback (Telltales)`,
  },
  {
    value: 91,
    description: `J1939 Parameter Right Turn Lamps Feedback (Telltale)`,
  },
  { value: 92, description: `Front Left Turn Signal DO` },
  { value: 93, description: `Front Left Turn Signal Current Sense AI` },
  { value: 94, description: `Front Right Turn Signal DO` },
  { value: 95, description: `Front Right Turn Signal Current Sense AI` },
  { value: 96, description: `Rear Left Turn Signal DO` },
  { value: 97, description: `Rear Left Turn Signal Current Sense AI` },
  { value: 98, description: `Rear Right Turn Signal DO` },
  { value: 99, description: `Rear Right Turn Signal Current Sense AI` },
  {
    value: 100,
    description: `J1939 Wheel Based Vehicle Speed`,
    short: 'SPEED',
    isInput: true,
    isOutput: false,
    unit: (displayValue) =>
      `MPH / ${Math.round((Number(displayValue) * 411.991) / 256)} KPH`,
    disp: (op, val) => `SPEED ${op} ${val}`, // XX unused apparently
    displayValue: (apiValue) => `${Math.round(Number(apiValue) / 411.991)}`,
    apiValue: (displayValue) => displayValue,
  },
  { value: 101, description: `Washer Level DI` },
  {
    value: 102,
    description: `J1939 Parameter Washer Fluid Level`,
    short: 'WSH F.LVL',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `WSH F.LVL ${op} ${val}`,
  },
  { value: 103, description: `J1939 Parameter Windshield Washer Command` },
  { value: 104, description: `J1939 Parameter Windshield Washer Feedback` },
  {
    value: 105,
    description: `Washer Pump DO`,
    short: 'WSH PMP',
    isInput: false,
    isOutput: true,
    disp: (op, value) => {
      if (value > 0) {
        return `WSH PMP ON`
      }
      return `WSH PMP OFF`
    },
  },
  { value: 106, description: `Washer Pump Current Sense AI` },
  { value: 107, description: `Wiper Commutator DI` },
  { value: 108, description: `J1939 Wiper-Park Command Switch Position` },
  {
    value: 109,
    description: `J1939 Wiper-Park Command Switch Position Feedback`,
  },
  { value: 110, description: `J1939 Parameter Wiper On/Off Switch Position` },
  { value: 111, description: `J1939 Parameter Wiper On/Off Switch Feedback` },
  { value: 112, description: `J1939 Wiper-Low Command` },
  { value: 113, description: `J1939 Wiper-Low Feedback` },
  { value: 114, description: `J1939 Wiper-High Command` },
  { value: 115, description: `J1939 Wiper-High Feedback` },
  { value: 116, description: `Wiper Low DO` },
  { value: 117, description: `Wiper Low Current Sense AI` },
  { value: 118, description: `Wiper High DO` },
  { value: 119, description: `Wiper High Current Sense AI` },
  {
    value: SLOT_TYPES.IGNITION,
    description: `Ignition State`,
    short: 'IGN STATE',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `IGN STATE ${op} ${val}`,
    displayValue: (val) => getIgnitionValue(val),
    // menu returns index, not displayed value
    apiValue: (val) => val,
  },
  { value: 121, description: `Headlamp State` },
  { value: 122, description: `Headlamp Switch` },
  { value: 123, description: `Vehicle Speed (BIN8)` },
  {
    value: 124,
    description: `Blinker On`,
    short: 'BLNKR',
    isInput: false,
    isOutput: true,
    disp: (op, value) => {
      if (value > 0) {
        return `BLNKR ON`
      }
      return `BLNKR OFF`
    },
  },
  { value: 125, description: `AMU Blinker` },
  { value: 126, description: `AMU Fault Blinker` },
  { value: 127, description: `TRUE` },
  { value: 128, description: `FALSE` },
  { value: 129, description: `DRL On` },
  {
    value: 130,
    description: `Marker Switch Position with 30 second timeout`,
  },
  { value: 131, description: `MLOGIC Carry 00` },
  { value: 132, description: `MLOGIC Carry 01` },
  { value: 133, description: `MLOGIC Carry 02` },
  { value: 134, description: `MLOGIC Carry 03` },
  { value: 135, description: `MLOGIC Carry 04` },
  { value: 136, description: `MLOGIC Carry 05` },
  { value: 137, description: `MLOGIC Carry 06` },
  { value: 138, description: `MLOGIC Carry 07` },
  { value: 139, description: `MLOGIC Carry 08` },
  { value: 140, description: `MLOGIC Carry 09` },
  { value: 141, description: `MLOGIC Carry 10` },
  { value: 142, description: `MLOGIC Carry 11` },
  { value: 143, description: `MLOGIC Carry 12` },
  { value: 144, description: `MLOGIC Carry 13` },
  { value: 145, description: `MLOGIC Carry 14` },
  { value: 146, description: `MLOGIC Carry 15` },
  { value: 147, description: `MLOGIC Carry 16` },
  { value: 148, description: `MLOGIC Carry 17` },
  { value: 149, description: `MLOGIC Carry 18` },
  { value: 150, description: `MLOGIC Carry 19` },
  {
    value: 151,
    description: `Timer 0`,
    outputDisplay: (val) => `Timer 0 = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 152,
    description: `5 sec wiper timer`,
    outputDisplay: (val) =>
      `5 sec wiper timer = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 153,
    description: `17 sec wiper timer`,
    outputDisplay: (val) =>
      `17 sec wiper timer = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 154,
    description: `Timer 3`,
    outputDisplay: (val) => `Timer 3 = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 155,
    description: `Timer 4`,
    outputDisplay: (val) => `Timer 4 = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 156,
    description: `Timer 5`,
    outputDisplay: (val) => `Timer 5 = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 157,
    description: `Timer 6`,
    outputDisplay: (val) => `Timer 6 = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 158,
    description: `Timer 7`,
    outputDisplay: (val) => `Timer 7 = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 159,
    description: `Timer 8`,
    outputDisplay: (val) => `Timer 8 = ${getTimerOutputSemanticValue(val)}`,
  },
  {
    value: 160,
    description: `Timer 9`,
    outputDisplay: (val) => `Timer 9 = ${getTimerOutputSemanticValue(val)}`,
  },
  { value: 161, description: `BHM VBAT 1` },
  { value: 162, description: `BHM VBAT 2` },
  { value: 163, description: `BHM VBAT 3` },
  { value: 164, description: `BHM VBAT 4` },
  { value: 165, description: `BHM VBAT 5` },
  {
    value: 166,
    description: `Initialization Slot 0 - Park Brake Wetting Current`,
  },
  {
    value: 167,
    description: `Initialization Slot 1 - Low Air Pressure Wetting Current`,
  },
  {
    value: 168,
    description: `Initialization Slot 2 - AMU 0 Wetting Current`,
  },
  {
    value: 169,
    description: `Initialization Slot 3 - AMU 1 Wetting Current`,
  },
  {
    value: 170,
    description: `Initialization Slot 4 - AMU 2 Wetting Current`,
  },
  {
    value: 171,
    description: `Initialization Slot 5 - AMU 3 Wetting Current`,
  },
  {
    value: 172,
    description: `Initialization Slot 6 - BHM Spare Ignition 8.0 Amp Output`,
  },
  { value: 173, description: `Initialization Slot 7` },
  { value: 174, description: `Initialization Slot 8` },
  { value: 175, description: `Initialization Slot 9` },
  { value: 176, description: `Initialization Slot 10` },
  { value: 177, description: `Initialization Slot 11` },
  { value: 178, description: `Initialization Slot 12` },
  { value: 179, description: `Initialization Slot 13` },
  { value: 180, description: `Initialization Slot 14` },
  { value: 181, description: `Initialization Slot 15` },
  { value: 182, description: `Air Filter Restriction DI` },
  {
    value: 183,
    description: `J1939 parameter Air Filter Differential Pressure`,
  },
  { value: 184, description: `85 PSI Air Pressure Line` },
  { value: 185, description: `Air Horn Foot Switch` },
  { value: 186, description: `Air Horn Solenoid` },
  { value: 187, description: `Air Horn Solenoid Driver Feedback` },
  { value: 188, description: `Air Horn Dash Switch` },
  { value: 189, description: `Air Horn Dash Switch Indicator` },
  { value: 190, description: `Axle Lift Dash Switch` },
  { value: 191, description: `Axle Lift Dash Switch Indicator` },
  { value: 192, description: `Axle Lift Solenoid` },
  { value: 193, description: `Axle Lift Solenoid Driver Feedback` },
  { value: 194, description: `Axle Lift AMU Pressure Feedback` },
  { value: 195, description: `Axle Shift Dash Switch` },
  { value: 196, description: `Axle Shift Dash Switch Indicator` },
  { value: 197, description: `Axle Shift Solenoid` },
  { value: 198, description: `Axle Shift Solenoid Driver Feedback` },
  { value: 199, description: `Axle Shift AMU Pressure Feedback` },
  { value: 200, description: `Brake Line Air Dryer DO` },
  { value: 201, description: `Brake Line Air Dryer Driver Feedback` },
  { value: 202, description: `Cluster Optional Buzzer` },
  { value: 203, description: `Cluster Optional Buzzer Feedback` },
  { value: 204, description: `DRL DO` },
  { value: 205, description: `DRL Current Sense AI` },
  { value: 206, description: `End of Frame Air Dash Switch` },
  { value: 207, description: `End of Frame Air Dash Switch Indicator` },
  { value: 208, description: `End of Frame Solenoid Output` },
  { value: 209, description: `End of Frame Solenoid Driver Feedback` },
  { value: 210, description: `End of Frame AMU Pressure Feedback` },
  {
    value: 211,
    description: `Engine Brake On/Off Switch`,
    short: 'ENG BRK',
    isInput: true,
    isOutput: false,
    disp: (op, value) => {
      if (value > 0) {
        return `ENG BRK ON`
      }
      return `ENG BRK OFF`
    },
  },
  { value: 212, description: `Engine Brake Low DI` },
  { value: 213, description: `Engine Brake Med DI` },
  { value: 214, description: `Engine Brake High DI` },
  { value: 215, description: `J1939 Parameter Engine Retarder Selection` },
  { value: 216, description: `Engine Brake Switch Indicator DO` },
  { value: 217, description: `5th Wheel Slide Dash Switch` },
  { value: 218, description: `5th Wheel Slide Dash Switch Indicator` },
  { value: 219, description: `5th Wheel Slide Solenoid` },
  { value: 220, description: `5th Wheel Slide Driver Feedback` },
  { value: 221, description: `5th Wheel Slide AMU Pressure Feedback` },
  { value: 222, description: `Fire Pump Dash Switch` },
  { value: 223, description: `Fire Pump Dash Switch Indicator` },
  { value: 224, description: `Fire Pump Solenoid` },
  { value: 225, description: `Fire Pump Driver Feedback` },
  { value: 226, description: `Road Mode Output` },
  { value: 227, description: `Fire Pump AMU Pressure Feedback` },
  { value: 228, description: `Fire Pump Telltale` },
  { value: 229, description: `Fog Lamp Switch DI` },
  { value: 230, description: `Fog Lamp Switch Indicator DO` },
  { value: 231, description: `Fog Lamp DO` },
  { value: 232, description: `Fog Lamp Current Sense AI` },
  { value: 233, description: `Front Differential Lock Dash Switch` },
  {
    value: 234,
    description: `Front Differential Lock Dash Switch Indicator`,
  },
  { value: 235, description: `Front Differential Lock Solenoid` },
  { value: 236, description: `Front Differential Lock Voltage Feedback` },
  { value: 237, description: `Front Differential Lock AMU Feedback` },
  { value: 238, description: `Fuel Water Seperator Heater DO` },
  { value: 239, description: `Fuel Water Seperator Heater Current Sense AI` },
  { value: 240, description: `Fuel Water Seperator Heater Status DI` },
  { value: 241, description: `Fuel Water Seperator Sensor DI` },
  { value: 242, description: `J1939 Parameter Water In Fuel Indicator` },
  { value: 243, description: `Interaxle Dash Switch` },
  { value: 244, description: `Interaxle Dash Switch Indicator` },
  { value: 245, description: `Interaxle Solenoid` },
  { value: 246, description: `Interaxle Driver Feedback` },
  { value: 247, description: `Interaxle AMU Pressure Feedback` },
  { value: 248, description: `Low Air Input` },
  { value: 249, description: `Low Air Indicator` },
  { value: 250, description: `Marker Interrupt Switch` },
  { value: 251, description: `Mirror Heater Switch DI` },
  { value: 252, description: `Mirror Heater Switch Indicator DO` },
  { value: 253, description: `Heated Mirrors DO` },
  { value: 254, description: `Heated Mirrors Current Sense AI` },
  { value: 255, description: `Heated Mirrors Feedback AI` },
  { value: 256, description: `OPT Switch DI` },
  { value: 257, description: `OPT Switch Indicator DO` },
  { value: 258, description: `OPT Output DO` },
  { value: 259, description: `OPT Driver Feedback` },
  { value: 260, description: `Rear 1 Differential Lock Dash Switch` },
  {
    value: 261,
    description: `Rear 1 Differential Lock Dash Switch Indicator`,
  },
  { value: 262, description: 'Rear 1 Differential Lock Solenoid Output' },
  {
    value: 263,
    description: 'Rear 1 Differential Lock Solenoid Driver Feedback',
  },
  {
    value: 264,
    description: 'Rear 1 Differential Lock AMU Pressure Feedback',
  },
  { value: 265, description: 'Rear 2 Differential Lock Dash Switch' },
  {
    value: 266,
    description: 'Rear 2 Differential Lock Dash Switch Indicator',
  },
  { value: 267, description: 'Rear 2 Differential Lock Solenoid' },
  {
    value: 268,
    description: 'Rear 2 Differential Lock Solenoid Driver Feedback',
  },
  { value: 269, description: 'Rear 2 Differential Lock AMU Feedback' },
  { value: 270, description: 'Snow Plow Dash Switch' },
  { value: 271, description: 'Snow Plow Dash Switch Indicator' },
  { value: 272, description: 'Snow Plow Relay' },
  { value: 273, description: 'Snow Plow Relay Driver Feedback' },
  { value: 274, description: 'Spotlight Switch' },
  { value: 275, description: 'Spotlight Switch Indicator' },
  { value: 276, description: 'Spotlight Output' },
  { value: 277, description: 'Spotlights Driver Feedback' },
  { value: 278, description: 'Suspension Dump Dash Switch' },
  { value: 279, description: 'Suspension Dump Dash Switch Indicator' },
  { value: 280, description: 'Suspension Dump Solenoid' },
  { value: 281, description: 'Suspension Dump Driver Feedback' },
  { value: 282, description: 'Suspension Dump AMU Pressure Feedback' },
  { value: 283, description: 'Suspension Proportioning Dash Switch' },
  {
    value: 284,
    description: 'Suspension Proportioning Dash Switch Indicator',
  },
  { value: 285, description: 'Suspension Proportioning Solenoid' },
  { value: 286, description: 'Suspension Proportioning Driver Feedback' },
  {
    value: 287,
    description: 'Suspension Proportioning AMU Pressure Feedback',
  },
  { value: 288, description: 'Transmission Oil Temperature Sensor' },
  { value: 289, description: 'Transmission Oil Temperature' },
  { value: 290, description: 'Utility Lamp Switch' },
  { value: 291, description: 'Utility Lamp Switch Indicator' },
  { value: 292, description: 'Utility Lamp Output' },
  { value: 293, description: 'Utility Lamp Driver Feedback' },
  { value: 294, description: 'Wig wag Dash Switch' },
  { value: 295, description: 'Emergency Master Dash Switch' },
  { value: 296, description: 'DRL Driver Voltage Feedback' },
  { value: 297, description: 'Brake Line Air Dryer Driver Voltage Feedback' },
  { value: 298, description: 'Ignition feedback (Current Sense)' },
  { value: 299, description: 'Ignition Voltage Feedback' },
  { value: 300, description: 'Trailer Power Relay' },
  { value: 301, description: 'Winch' },
  { value: 302, description: 'DC Pump' },
  {
    value: 303,
    description: 'Utility Mode Switch',
    short: 'UT MODE SW',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `UT MODE SW ${op} ${val}`,
  },
  { value: 304, description: 'Utility Mode Switch Indicator' },
  {
    value: 305,
    description: 'Utility Mode',
    short: 'UT MODE',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `UT MODE ${op} ${val}`,
  },
  {
    value: 306,
    description: 'Power Take-Off',
    short: 'PTO',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `UT MODE ${op} ${val}`,
    outputDisplay: (val) =>
      `PTO ${val === '0' ? inputStrings.off : inputStrings.on}`,
    displayValue: (val) => (val === '0' ? inputStrings.off : inputStrings.on),
    apiValue: (val) => (val === '1' ? 1 : 0),
  },
  { value: 307, description: 'PTO Feedback' },
  { value: 308, description: 'Strobe Light' },
  { value: 309, description: 'Strobe Light Switch Indicator' },
  { value: 310, description: 'Strobe Light Switch' },
  { value: 311, description: 'Air Horn Dash Switch' },
  {
    value: 312,
    description: 'Engine RPM',
    short: 'ENG RPM',
    isInput: true,
    isOutput: false,
    unit: 'RPM',
    disp: (op, val) => `ENG RPM ${op} ${val}`,
    displayValue: (apiValue) =>
      String(
        apiValue === stringMaxVal
          ? inputStrings.unavailable
          : Number(apiValue) / 8
      ),
    apiValue: (displayValue) =>
      [inputStrings.unavailable, stringMaxVal].includes(String(displayValue))
        ? stringMaxVal
        : displayValue,
  },
  { value: 313, description: 'Backlighting Level from ICU' },
  { value: 314, description: 'Switch Panel Backlighting Decrement Switch' },
  { value: 315, description: 'Switch Panel Backlighting Increment Switch' },
  { value: 316, description: 'Transmission Crank Enable' },
  { value: 317, description: 'Axle Lift 2 Switch' },
  { value: 318, description: 'Axle Lift 2 Switch Indicator' },
  { value: 319, description: 'Axle Lift 2 Solenoid' },
  { value: 320, description: 'Axle Lift 2 Voltage Feedback' },
  { value: 321, description: 'Axle Lift 2 Pressure Feedback' },
  { value: 322, description: 'PTO 1 Switch' },
  {
    value: 323,
    description: 'PTO 1 Switch Indicator',
    short: 'PTO1 SW IND',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `PTO1 SW IND ${op} ${val}`,
  },
  {
    value: 324,
    description: 'PTO1 Output',
    short: 'PTO1 OUT',
    isInput: true,
    isOutput: true,
    disp: (op, val) =>
      `PTO1 OUT ${op} ${
        val === '0' ? inputStrings.disengaged : inputStrings.engaged
      }`,
    // no displayValue because we don't have value entry for output slots
    outputDisplay: (val) =>
      `PTO1 OUT ${
        val === '0' ? inputStrings.disengaged : inputStrings.engaged
      }`,
    apiValue: (val) => (val === inputStrings.disengaged ? 0 : 1),
  },
  { value: 325, description: 'PTO 1 Voltage Feedback' },
  {
    value: 326,
    description: 'PTO 1 Pressure Feedback',
    short: 'PTO1 PRESS FDBACK',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `PTO1 PRESS FDBACK ${op} ${val}`,
  },
  { value: 327, description: 'PTO 2 Switch' },
  { value: 328, description: 'PTO 2 Switch Indicator' },
  { value: 329, description: 'PTO 2 Output' },
  { value: 330, description: 'PTO 2 Voltage Feedback' },
  { value: 331, description: 'PTO 2 Pressure Feedback' },
  { value: 332, description: 'Starter Inhibit' },
  { value: 333, description: 'Axle Lift 1 - 2nd Solenoid' },
  { value: 334, description: 'Axle Lift 2 - 2nd Solenoid' },
  { value: 335, description: 'CHM Low Beam DRL Support Input' },
  { value: 336, description: 'Left Low Beam PWM Duty Cycle' },
  { value: 337, description: 'Right Low Beam PWM Duty Cycle' },
  { value: 338, description: 'Right Low Beam PWM Frequency' },
  {
    value: 339,
    description: 'Utility Mode Inhibit',
    short: 'UT MODE INHIBIT',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `UT MODE INHIBIT ${op} ${val}`,
  },
  { value: 340, description: 'MLOGIC Carry 20' },
  { value: 341, description: 'MLOGIC Carry 21' },
  { value: 342, description: 'MLOGIC Carry 22' },
  { value: 343, description: 'MLOGIC Carry 23' },
  { value: 344, description: 'MLOGIC Carry 24' },
  { value: 345, description: 'MLOGIC Carry 25' },
  { value: 346, description: 'MLOGIC Carry 26' },
  { value: 347, description: 'MLOGIC Carry 27' },
  { value: 348, description: 'MLOGIC Carry 28' },
  { value: 349, description: 'MLOGIC Carry 29' },
  { value: 350, description: 'MLOGIC Carry 30' },
  { value: 351, description: 'MLOGIC Carry 31' },
  { value: 352, description: 'MLOGIC Carry 32' },
  { value: 353, description: 'MLOGIC Carry 33' },
  { value: 354, description: 'MLOGIC Carry 34' },
  { value: 355, description: 'MLOGIC Carry 35' },
  { value: 356, description: 'MLOGIC Carry 36' },
  { value: 357, description: 'MLOGIC Carry 37' },
  { value: 358, description: 'MLOGIC Carry 38' },
  { value: 359, description: 'MLOGIC Carry 39' },
  { value: 360, description: 'Hazard lights Control' },
  { value: 361, description: 'Vehicle Speed within Range' },
  { value: 362, description: 'Engine Speed within Range' },
  { value: 363, description: 'Transmission State' },
  { value: 364, description: 'PreFlight Activation Switch' },
  {
    value: 365,
    description: 'CHM VBAT 1',
    short: 'CHM VBAT 1',
    isInput: true,
    isOutput: true,
    unit: 'V',
    disp: (op, val) => `CHM VBAT 1 ${op} ${val}`,
    displayValue: (apiValue) =>
      `${
        String(apiValue) === stringMaxVal
          ? inputStrings.unavailable
          : Math.round10(Number(apiValue) * 0.104 + 0.4567, -1)
      }`,
    apiValue: (displayValue) => {
      if (
        [inputStrings.unavailable, stringMaxVal].includes(String(displayValue))
      ) {
        return stringMaxVal
      }
      return displayValue
      // return String(Math.round((Number(displayValue) - 0.4567) / 0.104))
    },
  },

  { value: 366, description: 'CHM BATTERY Voltage (2)' },
  { value: 367, description: 'CHM BATTERY Voltage (3)' },
  { value: 368, description: 'CAN Odometer Value' },
  { value: 369, description: 'Starter Inhibited Reason Signal' },
  { value: 370, description: 'Ignition State Data' },
  { value: 371, description: 'Starter Output Status' },
  { value: 372, description: 'PreFlight Activation Switch Indicator' },
  { value: 373, description: 'PreFlight Activation Switch (for Group 3)' },
  { value: 374, description: 'Ignition Output Status Signal' },
  {
    value: 375,
    description: 'MLOGIC 2 CARRY 00',
    short: 'MLOGIC 2 CARRY 00',
    isInput: true,
    isOutput: true,
    disp: (op, val) => `MLOGIC 2 CARRY 00 ${op} ${val}`,
  },
  { value: 376, description: 'MLOGIC 2 CARRY 01' },
  { value: 377, description: 'MLOGIC 2 CARRY 02' },
  { value: 378, description: 'MLOGIC 2 CARRY 03' },
  { value: 379, description: 'MLOGIC 2 CARRY 04' },
  { value: 380, description: 'MLOGIC 2 CARRY 05' },
  { value: 381, description: 'MLOGIC 2 CARRY 06' },
  { value: 382, description: 'MLOGIC 2 CARRY 07' },
  { value: 383, description: 'MLOGIC 2 CARRY 08' },
  { value: 384, description: 'MLOGIC 2 CARRY 09' },
  { value: 385, description: 'MLOGIC 2 CARRY 10' },
  { value: 386, description: 'MLOGIC 2 CARRY 11' },
  { value: 387, description: 'MLOGIC 2 CARRY 12' },
  { value: 388, description: 'MLOGIC 2 CARRY 13' },
  { value: 389, description: 'MLOGIC 2 CARRY 14' },
  { value: 390, description: 'MLOGIC 2 CARRY 15' },
  { value: 391, description: 'MLOGIC 2 CARRY 16' },
  { value: 392, description: 'MLOGIC 2 CARRY 17' },
  { value: 393, description: 'MLOGIC 2 CARRY 18' },
  { value: 394, description: 'MLOGIC 2 CARRY 19' },
  { value: 395, description: 'MLOGIC 2 CARRY 20' },
  { value: 396, description: 'MLOGIC 2 CARRY 21' },
  { value: 397, description: 'MLOGIC 2 CARRY 22' },
  { value: 398, description: 'MLOGIC 2 CARRY 23' },
  { value: 399, description: 'MLOGIC 2 CARRY 24' },
  { value: 400, description: 'MLOGIC 2 CARRY 25' },
  { value: 401, description: 'MLOGIC 2 CARRY 26' },
  { value: 402, description: 'MLOGIC 2 CARRY 27' },
  { value: 403, description: 'MLOGIC 2 CARRY 28' },
  { value: 404, description: 'MLOGIC 2 CARRY 29' },
  { value: 405, description: 'MLOGIC 2 CARRY 30' },
  { value: 406, description: 'MLOGIC 2 CARRY 31' },
  { value: 407, description: 'MLOGIC 2 CARRY 32' },
  { value: 408, description: 'MLOGIC 2 CARRY 33' },
  { value: 409, description: 'MLOGIC 2 CARRY 34' },
  { value: 410, description: 'MLOGIC 2 CARRY 35' },
  { value: 411, description: 'MLOGIC 2 CARRY 36' },
  { value: 412, description: 'MLOGIC 2 CARRY 37' },
  { value: 413, description: 'MLOGIC 2 CARRY 38' },
  { value: 414, description: 'MLOGIC 2 CARRY 39' },
  { value: 415, description: 'MLOGIC 2 CARRY 40' },
  { value: 416, description: 'MLOGIC 2 CARRY 41' },
  { value: 417, description: 'MLOGIC 2 CARRY 42' },
  { value: 418, description: 'MLOGIC 2 CARRY 43' },
  { value: 419, description: 'MLOGIC 2 CARRY 44' },
  { value: 420, description: 'MLOGIC 2 CARRY 45' },
  { value: 421, description: 'MLOGIC 2 CARRY 46' },
  { value: 422, description: 'MLOGIC 2 CARRY 47' },
  { value: 423, description: 'MLOGIC 2 CARRY 48' },
  { value: 424, description: 'MLOGIC 2 CARRY 49' },
  { value: 425, description: 'MLOGIC 2 CARRY 50' },
  { value: 426, description: 'MLOGIC 2 CARRY 51' },
  { value: 427, description: 'MLOGIC 2 CARRY 52' },
  { value: 428, description: 'MLOGIC 2 CARRY 53' },
  { value: 429, description: 'MLOGIC 2 CARRY 54' },
  { value: 430, description: 'MLOGIC 2 CARRY 55' },
  { value: 431, description: 'MLOGIC 2 CARRY 56' },
  { value: 432, description: 'MLOGIC 2 CARRY 57' },
  { value: 433, description: 'MLOGIC 2 CARRY 58' },
  { value: 434, description: 'MLOGIC 2 CARRY 59' },
  { value: 435, description: 'MLOGIC 2 CARRY 60' },
  { value: 436, description: 'MLOGIC 2 CARRY 61' },
  { value: 437, description: 'MLOGIC 2 CARRY 62' },
  { value: 438, description: 'MLOGIC 2 CARRY 63' },
  { value: 439, description: 'MLOGIC 2 CARRY 64' },
  { value: 440, description: 'MLOGIC 2 CARRY 65' },
  { value: 441, description: 'MLOGIC 2 CARRY 66' },
  { value: 442, description: 'MLOGIC 2 CARRY 67' },
  { value: 443, description: 'MLOGIC 2 CARRY 68' },
  { value: 444, description: 'MLOGIC 2 CARRY 69' },
  { value: 445, description: 'MLOGIC 2 CARRY 70' },
  { value: 446, description: 'MLOGIC 2 CARRY 71' },
  { value: 447, description: 'MLOGIC 2 CARRY 72' },
  { value: 448, description: 'MLOGIC 2 CARRY 73' },
  { value: 449, description: 'MLOGIC 2 CARRY 74' },
  { value: 450, description: 'MLOGIC 2 CARRY 75' },
  { value: 451, description: 'MLOGIC 2 CARRY 76' },
  { value: 452, description: 'MLOGIC 2 CARRY 77' },
  { value: 453, description: 'MLOGIC 2 CARRY 78' },
  { value: 454, description: 'MLOGIC 2 CARRY 79' },
  { value: 455, description: AVAILABLE_FOR_USE },
  { value: 456, description: AVAILABLE_FOR_USE },
  { value: 457, description: AVAILABLE_FOR_USE },
  { value: 458, description: AVAILABLE_FOR_USE },
  { value: 459, description: AVAILABLE_FOR_USE },
  { value: 460, description: AVAILABLE_FOR_USE },
  { value: 461, description: AVAILABLE_FOR_USE },
  { value: 462, description: AVAILABLE_FOR_USE },
  { value: 463, description: AVAILABLE_FOR_USE },
  { value: 464, description: AVAILABLE_FOR_USE },
  { value: 465, description: AVAILABLE_FOR_USE },
  { value: 466, description: AVAILABLE_FOR_USE },
  { value: 467, description: AVAILABLE_FOR_USE },
  { value: 468, description: AVAILABLE_FOR_USE },
  { value: 469, description: AVAILABLE_FOR_USE },
  { value: 470, description: AVAILABLE_FOR_USE },
  { value: 471, description: AVAILABLE_FOR_USE },
  { value: 472, description: AVAILABLE_FOR_USE },
  { value: 473, description: AVAILABLE_FOR_USE },
  { value: 474, description: AVAILABLE_FOR_USE },
  { value: 475, description: AVAILABLE_FOR_USE },
  { value: 476, description: AVAILABLE_FOR_USE },
  { value: 477, description: AVAILABLE_FOR_USE },
  { value: 478, description: AVAILABLE_FOR_USE },
  { value: 479, description: AVAILABLE_FOR_USE },
  { value: 480, description: AVAILABLE_FOR_USE },
  { value: 481, description: AVAILABLE_FOR_USE },
  { value: 482, description: AVAILABLE_FOR_USE },
  { value: 483, description: AVAILABLE_FOR_USE },
  { value: 484, description: AVAILABLE_FOR_USE },
  { value: 485, description: AVAILABLE_FOR_USE },
  { value: 486, description: AVAILABLE_FOR_USE },
  { value: 487, description: AVAILABLE_FOR_USE },
  { value: 488, description: AVAILABLE_FOR_USE },
  { value: 489, description: AVAILABLE_FOR_USE },
  { value: 490, description: AVAILABLE_FOR_USE },
  { value: 491, description: AVAILABLE_FOR_USE },
  { value: 492, description: AVAILABLE_FOR_USE },
  { value: 493, description: AVAILABLE_FOR_USE },
  { value: 494, description: AVAILABLE_FOR_USE },
  { value: 495, description: AVAILABLE_FOR_USE },
  { value: 496, description: AVAILABLE_FOR_USE },
  { value: 497, description: AVAILABLE_FOR_USE },
  { value: 498, description: AVAILABLE_FOR_USE },
  { value: 501, description: AVAILABLE_FOR_USE },
  { value: 502, description: AVAILABLE_FOR_USE },
  { value: 503, description: AVAILABLE_FOR_USE },
  { value: 504, description: AVAILABLE_FOR_USE },
  { value: 505, description: AVAILABLE_FOR_USE },
  { value: 506, description: AVAILABLE_FOR_USE },
  { value: 507, description: AVAILABLE_FOR_USE },
  { value: 508, description: AVAILABLE_FOR_USE },
  { value: 509, description: AVAILABLE_FOR_USE },
  { value: 510, description: AVAILABLE_FOR_USE },
  { value: 511, description: AVAILABLE_FOR_USE },
  { value: 512, description: AVAILABLE_FOR_USE },
  { value: 513, description: AVAILABLE_FOR_USE },
  { value: 514, description: AVAILABLE_FOR_USE },
  { value: 515, description: AVAILABLE_FOR_USE },
  { value: 516, description: AVAILABLE_FOR_USE },
  { value: 517, description: AVAILABLE_FOR_USE },
  { value: 518, description: AVAILABLE_FOR_USE },
  { value: 519, description: AVAILABLE_FOR_USE },
  { value: 520, description: AVAILABLE_FOR_USE },
  { value: 521, description: AVAILABLE_FOR_USE },
  { value: 522, description: AVAILABLE_FOR_USE },
  { value: 523, description: AVAILABLE_FOR_USE },
  { value: 524, description: AVAILABLE_FOR_USE },
  { value: 525, description: AVAILABLE_FOR_USE },
  { value: 526, description: AVAILABLE_FOR_USE },
  { value: 527, description: AVAILABLE_FOR_USE },
  { value: 528, description: AVAILABLE_FOR_USE },
  { value: 529, description: AVAILABLE_FOR_USE },
  { value: 530, description: AVAILABLE_FOR_USE },
  { value: 531, description: AVAILABLE_FOR_USE },
  { value: 532, description: AVAILABLE_FOR_USE },
  { value: 533, description: AVAILABLE_FOR_USE },
  { value: 534, description: AVAILABLE_FOR_USE },
  { value: 535, description: AVAILABLE_FOR_USE },
  { value: 536, description: AVAILABLE_FOR_USE },
  { value: 537, description: AVAILABLE_FOR_USE },
  { value: 538, description: AVAILABLE_FOR_USE },
  { value: 539, description: AVAILABLE_FOR_USE },
  { value: 540, description: AVAILABLE_FOR_USE },
  { value: 541, description: AVAILABLE_FOR_USE },
  { value: 542, description: AVAILABLE_FOR_USE },
  { value: 543, description: AVAILABLE_FOR_USE },
  { value: 544, description: AVAILABLE_FOR_USE },
  { value: 545, description: AVAILABLE_FOR_USE },
  { value: 546, description: AVAILABLE_FOR_USE },
  { value: 547, description: AVAILABLE_FOR_USE },
  { value: 548, description: AVAILABLE_FOR_USE },
  { value: 549, description: AVAILABLE_FOR_USE },
  {
    value: SLOT_TYPES.SMARTPLEX,
    description: 'SMARTPLEX PARM ENABLE',
    short: 'SMARTPLEX PARM ENABLE',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `SMARTPLEX PARM ENABLE ${op} ${val}`,
    displayValue: (val) => getIgnitionValue(val),
    apiValue: (val) => val,
  },
  { value: 551, description: AVAILABLE_FOR_USE },
  { value: 552, description: AVAILABLE_FOR_USE },
  { value: 553, description: AVAILABLE_FOR_USE },
  { value: 554, description: AVAILABLE_FOR_USE },
  { value: 555, description: 'Smart Switch 105 Position A for module 199' },
  {
    value: 556,
    description: 'Smart Switch 105 Position indicator for module 199',
  },
  { value: 557, description: 'For Module 264' },
  { value: 558, description: AVAILABLE_FOR_USE },
  { value: 559, description: AVAILABLE_FOR_USE },
  { value: 560, description: AVAILABLE_FOR_USE },
  { value: 561, description: 'PTC1 Message for module 275' },
  { value: 562, description: 'For Module 275' },
  {
    value: 563,
    description: 'Body Builder Output circuit 24F for module 275',
  },
  { value: 564, description: 'For Module 275' },
  { value: 565, description: 'For Module 66B' },
  { value: 566, description: 'For Module 66B' },
  { value: 567, description: 'For Module 66B' },
  { value: 568, description: 'In-Out Air Solenoid for module 199' },
  { value: 569, description: 'In-Out Air Solenoid Feedback for module 199' },
  {
    value: 570,
    description: 'Smart Switch 67 Position A (Wig Wag 27D) for module 27D/66B',
  },
  {
    value: 571,
    description:
      'Smart Switch 67 Position Indicator (Wig Wag 27D) for module 27D/66B	',
  },
  {
    value: 572,
    description:
      'Hazard Switch Input remapped to LS 572 (memory 64946) for module 27D/66B/885',
    short: 'Hazard Switch Input',
    isInput: true,
    isOutput: false,
    disp: (op, val) => `Hazard Switch Input ${op} ${val}`,
  },
  { value: 573, description: 'Mod 885, Neutral Switchfor module 885' },
  { value: 574, description: 'Mod 885, PTO Messagefor module 885' },
  {
    value: 575,
    description:
      'Mod 885, Engagement Consent - Transmission input shaft PTO 2for module 885',
  },
  {
    value: 576,
    description:
      'Mod 885, Engagement Status - Transmission input shaft PTO 2for module 885',
  },
  { value: 577, description: AVAILABLE_FOR_USE },
  { value: 578, description: AVAILABLE_FOR_USE },
  { value: 579, description: AVAILABLE_FOR_USE },
  { value: 580, description: 'Rail Mode for module 49A' },
  { value: 581, description: AVAILABLE_FOR_USE },
  { value: 582, description: AVAILABLE_FOR_USE },
  { value: 583, description: AVAILABLE_FOR_USE },
  { value: 584, description: AVAILABLE_FOR_USE },
  { value: 585, description: AVAILABLE_FOR_USE },
  { value: 586, description: AVAILABLE_FOR_USE },
  { value: 587, description: AVAILABLE_FOR_USE },
  { value: 588, description: AVAILABLE_FOR_USE },
  { value: 589, description: AVAILABLE_FOR_USE },
  { value: 590, description: AVAILABLE_FOR_USE },
  { value: 591, description: AVAILABLE_FOR_USE },
  { value: 592, description: AVAILABLE_FOR_USE },
  { value: 593, description: AVAILABLE_FOR_USE },
  { value: 594, description: AVAILABLE_FOR_USE },
  { value: 595, description: AVAILABLE_FOR_USE },
  { value: 596, description: AVAILABLE_FOR_USE },
  { value: 597, description: AVAILABLE_FOR_USE },
  { value: 598, description: AVAILABLE_FOR_USE },
  { value: 599, description: AVAILABLE_FOR_USE },
  { value: 600, description: AVAILABLE_FOR_USE },
  { value: 601, description: AVAILABLE_FOR_USE },
  { value: 602, description: AVAILABLE_FOR_USE },
  { value: 603, description: AVAILABLE_FOR_USE },
  { value: 604, description: AVAILABLE_FOR_USE },
  { value: 605, description: AVAILABLE_FOR_USE },
  { value: 606, description: AVAILABLE_FOR_USE },
  { value: 607, description: AVAILABLE_FOR_USE },
  { value: 608, description: AVAILABLE_FOR_USE },
  { value: 609, description: AVAILABLE_FOR_USE },
  { value: 610, description: AVAILABLE_FOR_USE },
  { value: 611, description: AVAILABLE_FOR_USE },
  { value: 612, description: AVAILABLE_FOR_USE },
  { value: 613, description: AVAILABLE_FOR_USE },
  { value: 614, description: AVAILABLE_FOR_USE },
  { value: 615, description: AVAILABLE_FOR_USE },
  { value: 616, description: AVAILABLE_FOR_USE },
  { value: 617, description: AVAILABLE_FOR_USE },
  { value: 618, description: AVAILABLE_FOR_USE },
  { value: 619, description: AVAILABLE_FOR_USE },
  { value: 620, description: AVAILABLE_FOR_USE },
  { value: 621, description: AVAILABLE_FOR_USE },
  { value: 622, description: AVAILABLE_FOR_USE },
  { value: 623, description: AVAILABLE_FOR_USE },
  { value: 624, description: AVAILABLE_FOR_USE },
  { value: 625, description: AVAILABLE_FOR_USE },
  { value: 626, description: AVAILABLE_FOR_USE },
  { value: 627, description: AVAILABLE_FOR_USE },
  { value: 628, description: AVAILABLE_FOR_USE },
  { value: 629, description: AVAILABLE_FOR_USE },
  { value: 630, description: AVAILABLE_FOR_USE },
  { value: 631, description: AVAILABLE_FOR_USE },
  { value: 632, description: AVAILABLE_FOR_USE },
  { value: 633, description: AVAILABLE_FOR_USE },
  { value: 634, description: AVAILABLE_FOR_USE },
  { value: 635, description: AVAILABLE_FOR_USE },
  { value: 636, description: AVAILABLE_FOR_USE },
  { value: 637, description: AVAILABLE_FOR_USE },
  { value: 638, description: AVAILABLE_FOR_USE },
  { value: 639, description: AVAILABLE_FOR_USE },
  { value: 640, description: AVAILABLE_FOR_USE },
  { value: 641, description: AVAILABLE_FOR_USE },
  { value: 642, description: AVAILABLE_FOR_USE },
  { value: 643, description: AVAILABLE_FOR_USE },
  { value: 644, description: AVAILABLE_FOR_USE },
  { value: 645, description: AVAILABLE_FOR_USE },
  { value: 646, description: AVAILABLE_FOR_USE },
  { value: 647, description: AVAILABLE_FOR_USE },
  { value: 648, description: AVAILABLE_FOR_USE },
  { value: 649, description: AVAILABLE_FOR_USE },
  { value: 650, description: AVAILABLE_FOR_USE },
  { value: 651, description: AVAILABLE_FOR_USE },
  { value: 652, description: AVAILABLE_FOR_USE },
  { value: 653, description: AVAILABLE_FOR_USE },
  { value: 654, description: AVAILABLE_FOR_USE },
  { value: 655, description: AVAILABLE_FOR_USE },
  { value: 656, description: AVAILABLE_FOR_USE },
  { value: 657, description: AVAILABLE_FOR_USE },
  { value: 658, description: AVAILABLE_FOR_USE },
  { value: 659, description: AVAILABLE_FOR_USE },
  { value: 660, description: AVAILABLE_FOR_USE },
  { value: 661, description: AVAILABLE_FOR_USE },
  { value: 662, description: AVAILABLE_FOR_USE },
  { value: 663, description: AVAILABLE_FOR_USE },
  { value: 664, description: AVAILABLE_FOR_USE },
  { value: 665, description: AVAILABLE_FOR_USE },
  { value: 666, description: AVAILABLE_FOR_USE },
  { value: 667, description: AVAILABLE_FOR_USE },
  { value: 668, description: AVAILABLE_FOR_USE },
  { value: 669, description: AVAILABLE_FOR_USE },
  { value: 670, description: AVAILABLE_FOR_USE },
  { value: 671, description: AVAILABLE_FOR_USE },
  { value: 672, description: AVAILABLE_FOR_USE },
  { value: 673, description: AVAILABLE_FOR_USE },
  { value: 674, description: AVAILABLE_FOR_USE },
  { value: 675, description: AVAILABLE_FOR_USE },
  { value: 676, description: AVAILABLE_FOR_USE },
  { value: 677, description: AVAILABLE_FOR_USE },
  { value: 678, description: AVAILABLE_FOR_USE },
  { value: 679, description: AVAILABLE_FOR_USE },
  { value: 680, description: AVAILABLE_FOR_USE },
  { value: 681, description: AVAILABLE_FOR_USE },
  { value: 682, description: AVAILABLE_FOR_USE },
  { value: 683, description: AVAILABLE_FOR_USE },
  { value: 684, description: AVAILABLE_FOR_USE },
  { value: 685, description: AVAILABLE_FOR_USE },
  { value: 686, description: AVAILABLE_FOR_USE },
  { value: 687, description: AVAILABLE_FOR_USE },
  { value: 688, description: AVAILABLE_FOR_USE },
  { value: 689, description: AVAILABLE_FOR_USE },
  { value: 690, description: AVAILABLE_FOR_USE },
  { value: 691, description: AVAILABLE_FOR_USE },
  { value: 692, description: AVAILABLE_FOR_USE },
  { value: 693, description: AVAILABLE_FOR_USE },
  { value: 694, description: AVAILABLE_FOR_USE },
  { value: 695, description: AVAILABLE_FOR_USE },
  { value: 696, description: AVAILABLE_FOR_USE },
  { value: 697, description: AVAILABLE_FOR_USE },
  { value: 698, description: AVAILABLE_FOR_USE },
  { value: 699, description: AVAILABLE_FOR_USE },
  { value: 700, description: AVAILABLE_FOR_USE },
  { value: 701, description: AVAILABLE_FOR_USE },
  { value: 702, description: AVAILABLE_FOR_USE },
  { value: 703, description: AVAILABLE_FOR_USE },
  { value: 704, description: AVAILABLE_FOR_USE },
  { value: 705, description: AVAILABLE_FOR_USE },
  { value: 706, description: AVAILABLE_FOR_USE },
  { value: 707, description: AVAILABLE_FOR_USE },
  { value: 708, description: AVAILABLE_FOR_USE },
  { value: 709, description: AVAILABLE_FOR_USE },
  { value: 710, description: AVAILABLE_FOR_USE },
  { value: 711, description: AVAILABLE_FOR_USE },
  { value: 712, description: AVAILABLE_FOR_USE },
  { value: 713, description: AVAILABLE_FOR_USE },
  { value: 714, description: AVAILABLE_FOR_USE },
  { value: 715, description: AVAILABLE_FOR_USE },
  { value: 716, description: AVAILABLE_FOR_USE },
  { value: 717, description: AVAILABLE_FOR_USE },
  { value: 718, description: AVAILABLE_FOR_USE },
  { value: 719, description: AVAILABLE_FOR_USE },
  { value: 720, description: AVAILABLE_FOR_USE },
  { value: 721, description: AVAILABLE_FOR_USE },
  { value: 722, description: AVAILABLE_FOR_USE },
  { value: 723, description: AVAILABLE_FOR_USE },
  { value: 724, description: AVAILABLE_FOR_USE },
  { value: 725, description: AVAILABLE_FOR_USE },
  { value: 726, description: AVAILABLE_FOR_USE },
  { value: 727, description: AVAILABLE_FOR_USE },
  { value: 728, description: AVAILABLE_FOR_USE },
  { value: 729, description: AVAILABLE_FOR_USE },
  { value: 730, description: AVAILABLE_FOR_USE },
  { value: 731, description: AVAILABLE_FOR_USE },
  { value: 732, description: AVAILABLE_FOR_USE },
  { value: 733, description: AVAILABLE_FOR_USE },
  { value: 734, description: AVAILABLE_FOR_USE },
  { value: 735, description: AVAILABLE_FOR_USE },
  { value: 736, description: AVAILABLE_FOR_USE },
  { value: 737, description: AVAILABLE_FOR_USE },
  { value: 738, description: AVAILABLE_FOR_USE },
  { value: 739, description: AVAILABLE_FOR_USE },
  { value: 740, description: AVAILABLE_FOR_USE },
  { value: 741, description: AVAILABLE_FOR_USE },
  { value: 742, description: AVAILABLE_FOR_USE },
  { value: 743, description: AVAILABLE_FOR_USE },
  { value: 744, description: AVAILABLE_FOR_USE },
  { value: 745, description: AVAILABLE_FOR_USE },
  { value: 746, description: AVAILABLE_FOR_USE },
  { value: 747, description: AVAILABLE_FOR_USE },
  { value: 748, description: AVAILABLE_FOR_USE },
  { value: 749, description: AVAILABLE_FOR_USE },
  { value: 750, description: AVAILABLE_FOR_USE },
  { value: 751, description: AVAILABLE_FOR_USE },
  { value: 752, description: AVAILABLE_FOR_USE },
  { value: 753, description: AVAILABLE_FOR_USE },
  { value: 754, description: AVAILABLE_FOR_USE },
  { value: 755, description: AVAILABLE_FOR_USE },
  { value: 756, description: AVAILABLE_FOR_USE },
  { value: 757, description: AVAILABLE_FOR_USE },
  { value: 758, description: AVAILABLE_FOR_USE },
  { value: 759, description: AVAILABLE_FOR_USE },
  { value: 760, description: AVAILABLE_FOR_USE },
  { value: 761, description: AVAILABLE_FOR_USE },
  { value: 762, description: AVAILABLE_FOR_USE },
  { value: 763, description: AVAILABLE_FOR_USE },
  { value: 764, description: AVAILABLE_FOR_USE },
  { value: 765, description: AVAILABLE_FOR_USE },
  { value: 766, description: AVAILABLE_FOR_USE },
  { value: 767, description: AVAILABLE_FOR_USE },
  { value: 768, description: AVAILABLE_FOR_USE },
  { value: 769, description: AVAILABLE_FOR_USE },
  { value: 770, description: AVAILABLE_FOR_USE },
  { value: 771, description: AVAILABLE_FOR_USE },
  { value: 772, description: AVAILABLE_FOR_USE },
  { value: 773, description: AVAILABLE_FOR_USE },
  { value: 774, description: AVAILABLE_FOR_USE },
  { value: 775, description: AVAILABLE_FOR_USE },
  { value: 776, description: AVAILABLE_FOR_USE },
  { value: 777, description: AVAILABLE_FOR_USE },
  { value: 778, description: AVAILABLE_FOR_USE },
  { value: 65535, description: 'DEFAULT' },
]

// Returns undefined if invalid.
export const getLogicalSlot = (logicalSlotID, slots = []) => {
  if (slots[parseInt(logicalSlotID)]) {
    return slots[parseInt(logicalSlotID)]
  }

  return inputs.find((i) => i.value === Number(logicalSlotID))
}

export const getInputDescription = (logicalSlotID, slots) => {
  const logicalSlot = getLogicalSlot(logicalSlotID, slots)
  return logicalSlot == null ? '' : logicalSlot.description
}

export const getDisplayValue = (logicalSlotID, apiValue) => {
  const logicalSlot = getLogicalSlot(logicalSlotID)
  return logicalSlot != undefined && // eslint-disable-line eqeqeq
    logicalSlot.displayValue &&
    apiValue !== stringMaxVal
    ? logicalSlot.displayValue(apiValue)
    : String(apiValue)
}

// All logical slot values are of the type 'string' from the db.
// Regardless of the component we use to
// allow the user to edit them, they should be kept a 'string' instate.
// XXX Can now remove String() in apiValue expressions.
export const getApiValue = (logicalSlotID, displayValue) => {
  const logicalSlot = getLogicalSlot(logicalSlotID)
  const ret =
    logicalSlot != undefined && logicalSlot.apiValue // eslint-disable-line eqeqeq
      ? logicalSlot.apiValue(displayValue)
      : displayValue
  return String(ret)
}
